import { Drawer } from '@mantine/core';
import { layout } from '../../theme/layout';
import { RightPanel } from './RightPanel';
import type { Field } from '../../types';

interface MemoOverlayDrawerProps {
  /** Drawer の表示状態 */
  opened: boolean;
  /** Drawer を閉じるコールバック */
  onClose: () => void;
  /** メモ表示対象の圃場一覧 */
  fields: Field[];
  /** メモのフィルタ・新規追加で利用するファーム ID */
  farmId: string | null;
}

/**
 * 圃場メモオーバーレイ Drawer
 *
 * SP/Tablet（RightPanel が表示されないブレイクポイント）で
 * ヘッダ右上のふきだしアイコンから呼び出して圃場メモを閲覧・追加するための
 * 右側スライド Drawer。ヘッダ高さ分だけ上端をオフセットし、ヘッダだけ残して
 * 画面全体を覆う。中身は既存の RightPanel をそのまま内包する。
 *
 * @param props - Drawer の props
 * @returns 右側スライド Drawer 要素
 */
export function MemoOverlayDrawer({ opened, onClose, fields, farmId }: MemoOverlayDrawerProps) {
  const headerOffsetPx = `${layout.header.height}px`;
  const contentHeight = `calc(100% - ${headerOffsetPx})`;

  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      position="right"
      size="100%"
      withCloseButton
      closeButtonProps={{ 'aria-label': 'メモを閉じる' }}
      overlayProps={{ backgroundOpacity: 0.5, blur: 2 }}
      styles={{
        inner: { top: headerOffsetPx, height: contentHeight },
        overlay: { top: headerOffsetPx, height: contentHeight },
        content: { height: '100%' },
      }}
    >
      <RightPanel fields={fields} farmId={farmId} />
    </Drawer>
  );
}
